import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
});

// Request interceptor → attach token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor → handle expired/invalid token
/* api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Clear old token
      localStorage.removeItem('authToken');

      // Redirect to login with message
      window.location.href = '/login?expired=true';
    }
    return Promise.reject(error);
  }
); */

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      // Clear all authentication data
      localStorage.removeItem('authToken');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('userRole');
      localStorage.removeItem('currentUser');

      // Tell App.js that the user has been logged out
      window.dispatchEvent(new Event('authLogout'));

      // Redirect to login with expired message
      window.location.href = '/login?expired=true';
    }

    return Promise.reject(error);
  }
);

export default api;

